import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import { getCookie } from "../../helpers/CookieHandler";
import imgHeaderStabilityToolMobile from "./assets/img_header_stability_tool_mobile.jpg";
import imgHeaderStabilityTool from "./assets/img_header_stability_tool.jpg";
import TETProductRule from "./V2_TET_Product_Rule";
import HeroImage from "../HeroImage";
import { PATIENT } from "../../constants";
import { api_v2 } from "../NewIndex.api";
import StaticConfig from "../StaticConfig";
import "./style.css";

const TETUserView = (props) => {
  const selectedCountry = getCookie("selectedEmployeeCountryLabel");
  const userType = getCookie("welcomeRole");
  const selectedUserType =
    userType === "HCP" || userType === "ABBVIE_EMPLOYEE"
      ? "HCP / Employee"
      : "Patient";
  const selectedLanguage = getCookie("welcomeLanguage");
  let content;
  let preferredTemp;
  if (userType === PATIENT) {
    content = props.pageContent.content.module.patientStabilityTool;
    preferredTemp = StaticConfig.Context.ComponentConfig.ppTempPreference;
  } else {
    content = props.pageContent.content.module.stabilityTool;
    preferredTemp = StaticConfig.Context.ComponentConfig.hcpTempPreference;
  }

  const [obj, setObj] = useState({
    aboutTET: "",
    TETPolicy: "",
    TETReference: "",
    multiTETInfo: "",
    contactInfo: ""
  });
  const [selectedTemperatueExcursionType, setSelectedTemperatueExcursionType] =
    useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showRule, setShowRule] = useState(false);

  useEffect(() => {
    const payload = {
      country: selectedCountry,
      userType: selectedUserType,
      language: selectedLanguage,
    };

    api_v2.fetchUserTETContent(payload, (res) => {
      if (res && Object.keys(res).length > 0) {
        setObj({
          aboutTET: res["About TET"] || "",
          TETPolicy: res["TET Policy"] || "",
          TETReference: res["TET Reference"] || "",
          multiTETInfo: res["Multiple TET Info"] || "",
          contactInfo: res["Contact Info"] || ""
        });
        setShowRule(true);
      } else {
        setShowRule(false);
        setObj({
          aboutTET:
            "Temperature Excursion is not configured for this country..!",
          TETPolicy: "",
          TETReference: "",
          multiTETInfo: "",
          contactInfo: ""
        });
      }
    });
  }, [selectedCountry, selectedUserType, selectedLanguage]);

  const handleSelectedTemperatueExcursionType = (event) => {
    setSelectedTemperatueExcursionType(event.target.value);
    setSelectedRole(null);
  };
  const handleSelectedRole = (event) => {
    setSelectedRole(event.target.value);
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <HeroImage
          title={"Temperature Excursion Tool"}
          imageDesktop={imgHeaderStabilityTool}
          imageMobile={imgHeaderStabilityToolMobile}
        />
        <div id="stability-tool" className="container stability-container">
          <div className="row">
            <div className="col-12">
              <div>
                <div className="row">
                  <div className="col-lg-10">
                    <p
                      className="text-left subtitle"
                      dangerouslySetInnerHTML={{ __html: obj.aboutTET }}
                    ></p>
                  </div>
                  <div className="col-lg-2">
                    <p className="text-right">
                      <b>{content.required}*</b>
                    </p>
                  </div>
                </div>
              </div>
              <br />
              {showRule && (
                <div>
                  {/* Questions here */}
                  <div className="stability_step_header">
                    <div className="row title">
                      <div className="col-12 TET_Question_Header">
                        {content.TETExposedQuestion}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <label className="custom-control custom-radio">
                          <input
                            id="radio-one"
                            className="custom-control-input"
                            type="radio"
                            name="temperatueExcursionType"
                            value="ONE"
                            onClick={handleSelectedTemperatueExcursionType}
                            defaultChecked={
                              selectedTemperatueExcursionType === "ONE"
                            }
                            checked={selectedTemperatueExcursionType === "ONE"}
                          />
                          <span className="custom-control-indicator"></span>
                          <span className="custom-control-description">
                            {content.oneTemperatureExcursion}
                          </span>
                        </label>
                        <label className="custom-control custom-radio">
                          <input
                            id="radio-multiple"
                            className="custom-control-input"
                            type="radio"
                            name="temperatueExcursionType"
                            value="MULTIPLE"
                            onClick={handleSelectedTemperatueExcursionType}
                            defaultChecked={
                              selectedTemperatueExcursionType === "MULTIPLE"
                            }
                            checked={
                              selectedTemperatueExcursionType === "MULTIPLE"
                            }
                          />
                          <span className="custom-control-indicator"></span>
                          <span className="custom-control-description">
                            {content.MultipleTemperatureExcursions}
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {userType !== PATIENT &&
                    selectedTemperatueExcursionType === "ONE" && (
                      <div className="stability_step_header">
                        <div className="row title">
                          <div className="col-12 TET_Question_Header">
                            {content.userQuestion}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <label className="custom-control custom-radio">
                              <input
                                id="radio-hcp"
                                className="custom-control-input"
                                type="radio"
                                name="userType"
                                value="Pharmacy / Physician / Hospital"
                                onChange={handleSelectedRole}
                                defaultChecked={
                                  selectedRole ===
                                  "Pharmacy / Physician / Hospital"
                                }
                              />
                              <span className="custom-control-indicator"></span>
                              <span className="custom-control-description">
                                {content.pph}
                              </span>
                            </label>
                            <label className="custom-control custom-radio">
                              <input
                                id="radio-patient"
                                className="custom-control-input"
                                type="radio"
                                name="userType"
                                value="Patient / Healthcare Provider on behalf of a specific Patient"
                                onChange={handleSelectedRole}
                                defaultChecked={
                                  selectedRole ===
                                  "Patient / Healthcare Provider on behalf of a specific Patient"
                                }
                              />
                              <span className="custom-control-indicator"></span>
                              <span className="custom-control-description">
                                {content.hcp}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  {selectedTemperatueExcursionType === "MULTIPLE" && (
                    <div className="stability-rec col-6">
                      <table style={{ margin: "10px" }}>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "top" }}>
                              <span
                                className="fa fa-info-circle"
                                style={{
                                  color: "rgb(81, 192, 239)",
                                  fontSize: "28px",
                                  padding: "0px 10px 0px 0px",
                                }}
                              ></span>
                            </td>
                            <td>
                              {obj.multiTETInfo && (
                                <p style={{ color: "#51c0ef !important" }}>
                                  <b
                                    dangerouslySetInnerHTML={{
                                      __html: obj.multiTETInfo,
                                    }}
                                  ></b>
                                </p>
                              )}
                              <button
                                className="btn btn-info btn-lg-wide submit-button btn-icon btn-rounded m-r-10"
                                style={{
                                  marginTop: "5px",
                                  height: "50px",
                                }}
                                value={null}
                                onClick={(e) =>
                                  handleSelectedTemperatueExcursionType(e)
                                }
                              >
                                <span style={{ fontSize: "14px" }}>
                                  {content.MultipleTETAgree}
                                </span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {selectedTemperatueExcursionType === "ONE" &&
                    (userType === PATIENT || selectedRole !== null) && (
                      <TETProductRule
                        selectedCountry={selectedCountry}
                        selectedLanguage={selectedLanguage}
                        selectedRole={selectedRole}
                        userType={userType}
                        content={content}
                        preferredTemp={preferredTemp}
                        contactInfo={obj.contactInfo}
                      />
                    )}
                </div>
              )}
              <br />
              <div className="row">
                <div className="col-12">
                  {obj.TETPolicy && (
                    <div
                      dangerouslySetInnerHTML={{ __html: obj.TETPolicy }}
                    ></div>
                  )}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  {obj.TETReference && (
                    <div
                      dangerouslySetInnerHTML={{ __html: obj.TETReference }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
  pageContent: state.pageContent,
});

export default connect(mapStateToProps, { notify })(TETUserView);



// WEBPACK FOOTER //
// ./src/mi-app/stabilityTool/V2_TET_User_View.js